import { useNavigate } from "@tanstack/react-router";
import { type PropsWithChildren, useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { ROUTES } from "../utils/constants/routes.constants";
import PageLoader from "../components/common/PageLoader";

type Props = {
  layout: "consultant" | "client";
};

const ProtectedRoute = ({ layout, children }: PropsWithChildren<Props>) => {
  const [hasPushed, setHasPushed] = useState(false);
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  // TODO: Implement the logic to redirect the user to the correct route based on their role (consultant or client)

  useEffect(() => {
    if (isLoading || hasPushed) return;

    if (!user) {
      navigate({ to: ROUTES.LOGIN });
      setHasPushed(true);
    }

    if (layout === "consultant" && user?.client) {
      navigate({ to: ROUTES.MARKETING_MONITORING });
      setHasPushed(true);
    }

    if (layout === "client" && user?.consultant) {
      navigate({ to: ROUTES.ORGANIZATIONS });
      setHasPushed(true);
    }
  }, [isLoading, user, hasPushed, navigate, layout]);

  if (isLoading) return <PageLoader />;

  return <>{children}</>;
};

export default ProtectedRoute;
